import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


window.addEventListener('unhandledrejection', (event) => {
  console.error('⚠️ Unhandled Promise Rejection:', event.reason);
});

window.addEventListener('error', (event) => {
  console.error('💥 Global Error Caught:', event.error || event.message);
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
